<template>
	<div id="personalIntegral">
		<div class="personalaccount_content">
			<div class="personalaccount_content_left">
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						基础功能
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box ">
							<router-link to="/shopcarIndex" >我的购物车</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalOrder" class="">订单管理</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box ">
							<router-link to="/personalservice" class="">售后申请</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box ">
							<router-link to="/personaCollection" class="">我的收藏</router-link>
							
						</div>
						<div class="personalaccount_content_left_item_content_box ">
							<router-link to="/personalHistory" class="">浏览历史</router-link>
						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						我的优惠信息
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box select_box">
							<router-link to="/personalPackage" class="select_box">我的红包</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box ">
							<router-link to="/personalIntegral" class="">我的积分</router-link>
							
						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						发票管理
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalTicket">申请开票</router-link>
						</div>
						
					</div>
				</div>
				
			</div>
			<div class="personalaccount_content_right">
				<div class="personalaccount_content_right_head">
					<div class="personalaccount_content_right_head_left">
						我的红包
					</div>
					<div class="personalaccount_content_right_head_right">
						<!--<img src="../../../assets/img/personalhome/bianji.png"/>
						编辑-->
					</div>
				</div>
				<div class="personalaccount_content_right_content_head">
					<div class="personalaccount_content_right_content_head_left">
						<input type="" name="" id="" value="" class="personalaccount_content_right_content_head_left_inp" />
						<span class="personalaccount_content_right_content_head_left_btn">领取红包</span>
					</div>
					<div class="personalaccount_content_right_content_head_right">
						<div @click="btnClick(1)" :class="tableBlock == 1 ? 'personalaccount_content_right_content_head_right_item right_item_hover' : 'personalaccount_content_right_content_head_right_item'">
							获取记录
						</div>
						<div @click="btnClick(2)" :class="tableBlock == 2 ? 'personalaccount_content_right_content_head_right_item right_item_hover' : 'personalaccount_content_right_content_head_right_item'">
							消费记录
						</div>
						<div @click="btnClick(3)" :class="tableBlock == 3 ? 'personalaccount_content_right_content_head_right_item right_item_hover' : 'personalaccount_content_right_content_head_right_item'">
							即将过期
						</div>
					</div>
				</div>
				<div class="hongbao_content" v-if="tableBlock == 0">
					<div class="hongbao_content_item" v-for="(item, index) in hongbaoData" :key="index">
						<img src="../../../assets/img/personalhome/hongbao_bg.png" class="hongbao_content_item_beijin"/>
						<img src="../../../assets/img/personalhome/qian.png" class="hongbao_content_item_beijin1"/>
						<div class="hongbao_content_item_price">
							{{item.price}}元
						</div>
						<div class="hongbao_content_item_js">
							{{item.js}}
						</div>
					</div>
				</div>
				<div class="" v-if="tableBlock == 1">
					<el-table :data="tableData" border style="width: 100%" :header-cell-style="getRowClass" :cell-style="cellStyle">
						<el-table-column prop="name" label="途径">
						</el-table-column>
						
						<el-table-column prop="num" label="数量">
						</el-table-column>
						<el-table-column prop="date" label="获取时间">
						</el-table-column>
					
				
					</el-table>
				</div>
				<div class="" v-if="tableBlock == 2">
					<el-table :data="tableData" border style="width: 100%" :header-cell-style="getRowClass" :cell-style="cellStyle">
						<el-table-column prop="name" label="途径">
						</el-table-column>
					
						<el-table-column prop="num" label="数量">
						</el-table-column>
						<el-table-column prop="date" label="消费时间">
						</el-table-column>
					
				
					</el-table>
				</div>
				<div class="" v-if="tableBlock == 3">
					<el-table :data="tableData" border style="width: 100%" :header-cell-style="getRowClass" :cell-style="cellStyle">
						<el-table-column prop="name" label="途径">
						</el-table-column>
					
						<el-table-column prop="num" label="数量">
						</el-table-column>
						<el-table-column prop="date" label="过期时间">
						</el-table-column>
					
				
					</el-table>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
  import DateSelect from '@/components/DateSelect'
	export default {
		name: 'personalIntegral',

    	components: { DateSelect },
		data() {
			return {
				fixedkey: false,
				tableBlock:0,
				hongbaoData:[{
					price:20,
					js:'满100元可用'
				},{
					price:20,
					js:'满100元可用'
				},{
					price:20,
					js:'满100元可用'
				},{
					price:20,
					js:'满100元可用'
				},{
					price:20,
					js:'满100元可用'
				},{
					price:20,
					js:'满100元可用'
				},{
					price:20,
					js:'满100元可用'
				},{
					price:20,
					js:'满100元可用'
				},{
					price:20,
					js:'满100元可用'
				}],
				tableData: [{
					name: '丽丽',
					
					date: '2019年8月24日',
					num: '6',
					
				},{
					name: '丽丽',
					
					date: '2019年8月24日',
					num: '6',
					
				},{
					name: '丽丽',
					
					date: '2019年8月24日',
					num: '6',
					
				},{
					name: '丽丽',
					
					date: '2019年8月24日',
					num: '6',
					
				},{
					name: '丽丽',
					
					date: '2019年8月24日',
					num: '6',
					
				},{
					name: '丽丽',
					
					date: '2019年8月24日',
					num: '6',
					
				}]
				
			
			}
		},
		mounted() {

			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				console.log()
				if(scrollTop >= 300) {
					this.fixedkey = true
				} else {
					this.fixedkey = false

				}
			},
			dateChange(obj) {
				console.log(obj.year + '-' + obj.month + '-' + obj.day);
			},
			btnClick(index){
				let that = this;
				that.tableBlock = index;
			},
			getRowClass({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(rowIndex === 0) {
					return "background: #eeeeee;font-size:18px;color:#333333;text-align:center;border-right:1px solid #dddddd;font-weight:500";
				} else {
					return "";
				}
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
					if (columnIndex == 5) {
						return "text-align:center;font-size:16px;color:#333333;";	
					}else{
						return "text-align:center;font-size:16px;color:#333333;";
					}
					
					
				
			},

		},

	}
</script>

<style scoped="scoped">
	#personalIntegral {
		width: 100%;
		background-color: #f6f6f6;
		padding-top: 20px;
		padding-bottom: 20px;
	}
	
	.personalaccount_content {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: nowrap;
		align-items: self-start;
	}
	
	.personalaccount_content_left {
		width: 170px;
		text-align: center;
		background: #ffffff;
	}
	
	.personalaccount_content_left_item_head {
		width: 100%;
		height: 50px;
		line-height: 50px;
		background: #dddddd;
		color: #333333;
		font-size: 18px;
		font-weight: 550;
	}
	
	.personalaccount_content_left_item_content {
		width: 100%;
	}
	
	.personalaccount_content_left_item_content_box {
		font-size: 16px;
		color: #333333;
		width: 100%;
		height: 40px;
		margin-top: 10px;
		line-height: 40px;
	}
	.select_box{
		background: #DC1E33;
		color: #ffffff;
	}
	.personalaccount_content_left_item_content_box span {
		color: #DC1E33;
	}
	
	.personalaccount_content_right {
		width: 1010px;
		margin-left: 20px;
		/*background: #ffffff;*/
	}
	
	.personalaccount_content_right_head {
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
		background: #fe818d;
		color: #ffffff;
		font-size: 18px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	.personalaccount_content_right_content_head{
		width: 100%;
		margin: 20px auto;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	.personalaccount_content_right_content_head_left_txt1{
		font-size: 33px;
		color: #333333;
	}
	.personalaccount_content_right_content_head_left_txt2{
		font-size: 43px;
		color: #DC1E33;
		display: inline-block;
		
	}
	.personalaccount_content_right_content_head_right{
		display: flex;
		flex-wrap: nowrap;
	}
	.personalaccount_content_right_content_head_right_item{
		width: 120px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #dddddd;
		box-shadow: 0 1px 3px #dddddd;
		text-align: center;
		background: white;
		margin-left: 50px;
		font-size: 16px;
		color: #333333;
		margin-top: 10px;
		cursor: pointer;
	}
	.right_item_hover{
		background: #DC1E33;
		color: #ffffff;
	}
	.personalaccount_content_right_content_head_left_inp{
		width: 240px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		padding-left: 10px;
		border: 1px solid #dddddd;
		background: #ffffff;
		
	}
	.personalaccount_content_right_content_head_left_btn{
		width: 120px;
		height: 40px;
		line-height: 40px;
		border: 1px solid #dddddd;
		box-shadow: 0 1px 3px #dddddd;
		text-align: center;
		background: white;
		margin-left: 30px;
		font-size: 16px;
		background: #DC1E33;
		color: #ffffff;
		margin-top: 10px;
		cursor: pointer;
		display: inline-block;
	}
	.hongbao_content{
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		
	}
	.hongbao_content_item{
		width: 182px;
		position: relative;
		height: 260px;
		margin-left: calc((100% - 182px * 5) / 10);
		margin-right: calc((100% - 182px * 5) / 10);
		margin-top: 20px;
	}
	.hongbao_content_item_beijin{
		display: inline-block;
		width: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}
	.hongbao_content_item_beijin1{
		display: inline-block;
		width: 50px;
		position: absolute;
		left: calc((100% - 50px) / 2);
		top: 40px;
	}
	.hongbao_content_item_price{
		width: 100%;
		text-align: center;
		color: #ffd445;
		font-size: 30px;
		position: absolute;
		left: 0;
		top: 100px;
	}
	.hongbao_content_item_js{
		width: 100%;
		text-align: center;
		color: #ffd445;
		font-size: 16px;
		position: absolute;
		left: 0;
		top: 160px;
	}
</style>